import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-quality-notice",
  "use": "icon-quality-notice-usage",
  "viewBox": "0 0 15 12",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" fill=\"none\" viewBox=\"0 0 15 12\" id=\"icon-quality-notice\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M3.681.375 0 3.935l7.559 7.69L15 3.945 11.508.374H3.681Zm.366 1.228h7.079l1.2 1.229H2.778l1.27-1.229ZM1.71 4.06h11.605l-5.76 5.945L1.71 4.06Z\" fill=\"#2B1453\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol